<template>
  <div class="page">
    <navigation>历史优惠</navigation>
    <van-tabs
      v-model="active"
      color="#333333"
      line-width="84"
      line-height="4"
      title-active-color="#333333"
      title-inactive-color="#BBBBBB"
      :sticky="false"
      :offset-top="128"
    >
      <van-tab title="优惠券">
        <div class="list">
          <div  v-for="(item,index) in couponsList" :key="index">
            <div class="item" v-if="item.couponV3 !== 'Y'">
              <span class="description" v-if="getPacketDescription(item)">{{ getPacketDescription(item) }}</span>
              <div class="center">
                <span class="title">
                  {{ getPacketType(item) }}
                </span>
                <span class="wapper">
                  <span class="amount">
                    {{ getDiscountValue(item) }}
                  </span>
                  <span class="unit">
                    {{ getPacketUnit(item) }}
                  </span>
                </span>
              </div>
              <div class="bottom">
                <span class="valid-time">
                  <!-- {{ getValidTimeDesc(item) }} -->
                </span>
                <span class="intrest-day">
                  {{ getPacketIntrestDesc(item) }}
                </span>
              </div>
              <div class="use-limit-desc" v-if="item.useLimitDesc&&item.activeType==='OPERA_COMMON'">{{item.useLimitDesc}}</div>
              <img src="./images/img_shiyong.png" alt="status" class="status" v-if="item.status === 'USED'">
              <img src="./images/img_guoqi.png" alt="status" class="status" v-else>
            </div>

            <div class="item" v-else >
              <span class="description" v-if="item.description">{{ item.description }}</span>
              <div class="center">
                <span class="title">
                  {{item.type}}
                </span>
                <span class="wapper">
                  <span class="amount">
                    {{item.amount}}
                  </span>
                  <span class="unit">
                    {{ item.unit }}
                  </span>
                </span>
              </div>
              <div class="bottom">
                <span class="valid-time">
                  <!-- {{ item.validTime }} -->
                </span>
                <span class="intrest-day">
                  {{ item.intrestDay }}
                </span>
              </div>
             
              <img src="./images/img_shiyong.png" alt="status" class="status" v-if="item.status === 'USED'">
              <img src="./images/img_guoqi.png" alt="status" class="status" v-else>
            </div>
          </div>
          <section v-if="couponsList.length === 0" class="no-data">
            <img src="./images/quan_empty.png">
            <div class="tips">这里空空如也...</div>
            <div class="sub-tips">积累更多信用，赚取更多优惠吧</div>
          </section>
        </div>
      </van-tab>
      <van-tab title="红包">
        <div class="list">
          <div  v-for="item in list" :key="item.activeId">
            <div class="item"  v-if="item.couponV3 !== 'Y'">
              <span class="description" v-if="getPacketDescription(item)">{{ getPacketDescription(item) }}</span>
              <div class="center">
                <span class="title">
                  {{ getPacketType(item) }}
                </span>
                <span class="wapper">
                  <span class="amount">
                    {{ getDiscountValue(item) }}
                  </span>
                  <span class="unit">
                    {{ getPacketUnit(item) }}
                  </span>
                </span>
              </div>
              <div class="bottom">
                <span class="valid-time">
                  <!-- {{ getValidTimeDesc(item) }} -->
                </span>
                <span class="intrest-day">
                  {{ getPacketIntrestDesc(item) }}
                </span>
              </div>
              <div class="use-limit-desc" v-if="item.useLimitDesc&&item.activeType==='OPERA_COMMON'">{{item.useLimitDesc}}</div>
              <img src="./images/img_shiyong.png" alt="status" class="status" v-if="item.status === 'USED'">
              <img src="./images/img_guoqi.png" alt="status" class="status" v-else>
            </div>
            <div class="item"  v-else>
              <span class="description" v-if="item.description">{{ item.description }}</span>
              <div class="center">
                <span class="title">
                  {{item.type}}
                </span>
                <span class="wapper">
                  <span class="amount">
                    {{item.amount}}
                  </span>
                  <span class="unit">
                    {{ item.unit }}
                  </span>
                </span>
              </div>
              <div class="bottom">
                <span class="valid-time">
                  <!-- {{ item.validTime }} -->
                </span>
                <span class="intrest-day">
                  {{ item.intrestDay }}
                </span>
              </div>
              <img src="./images/img_shiyong.png" alt="status" class="status" v-if="item.status === 'USED'">
              <img src="./images/img_guoqi.png" alt="status" class="status" v-else>
            </div>
          </div>
          <section v-if="list.length === 0" class="no-data">
            <img src="./images/quan_empty.png">
            <div class="tips">这里空空如也...</div>
            <div class="sub-tips">积累更多信用，赚取更多优惠吧</div>
          </section>
        </div>
      </van-tab>
      
    </van-tabs>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Tab, Tabs } from 'vant'
import TicketMaps from './tickets-map'

export default {
  name: 'quan-history',
  customReadyNotify: true,
  data () {
    return {
      list: [],
      active: 0,
      couponsList: [] // 优惠券
    }
  },
  components: {
    'van-tab': Tab,
    'van-tabs': Tabs,
    'quan-item': () => import('./components/quan-item')
  },
  async created () {
    await this.getCouponHistory()
    this.$bus.$emit('ready')
  },

  methods: {
    ...mapActions('activities', [
      'couponHistoryX'
    ]),
    // goV3Detail (item) {
    //   const { couponType, couponId } = item
    //   switch (couponType) {
    //     case 'CASH':
    //       this.$router.push(`/coupon/detail-v3-cash?couponRecordId=${couponId}`)
    //       break
    //     case 'FREE':
    //       this.$router.push(`/coupon/detail-v3-interest-free?couponRecordId=${couponId}`)
    //       break
    //     case 'LIMIT':
    //       this.$router.push(`/coupon/detail-v3-credit-coupon?couponRecordId=${couponId}`)
    //       break
    //   }
    // },

    async getCouponHistory () {
      const res = await this.couponHistoryX()
      if (res.success) {
        let data = res.data || []
        this.list = []
        this.couponsList = []

        // V3优惠券
        const map = {
          'CASH': '现金红包',
          'LIMIT': '专享提额券',
          'FREE': '免息券' 
        }
        const unitMap = {
          'FREE_AMOUNT': '元',
          'FREE_DAY': '天'
        }
        data.forEach(item => {
          if (item.couponV3 === 'Y') {
            const {
              value,
              couponId,
              couponName,
              couponType,
              discountType,
              leftTopCopyWriting,
              rightBottomCopyWriting,
              validTime,
              couponStatus,
              finalStatusMark,
              amt
            } = item.couponV3DTO
            const cashBack = finalStatusMark === 'Y' && !!amt
            if (couponType === 'CASH') {
              this.list.push({
                couponId,
                couponName,
                couponType,
                discountType,
                couponV3: 'Y',
                description: leftTopCopyWriting,
                type: map[couponType],
                amount: value,
                validTime: '有效期至' + this.formatDate(validTime, 'YYYY/MM/DD hh:mm:ss'),
                intrestDay: rightBottomCopyWriting,
                unit: '元',
                useType: 'useType',
                status: ['LIMIT_ACTIVE', 'FREE_WITHDRAW', 'CASH_WITHDRAW'].includes(couponStatus) ? 'USED' : couponStatus
              })
            }
         
            if (['FREE', 'LIMIT'].includes(couponType)) {
              this.couponsList.push({
                couponId,
                couponName,
                couponType,
                discountType,
                couponV3: 'Y',
                description: leftTopCopyWriting,
                type: map[couponType],
                amount: cashBack ? amt : value,
                validTime: '有效期至' + this.formatDate(validTime, 'YYYY/MM/DD hh:mm:ss'),
                intrestDay: rightBottomCopyWriting,
                unit: cashBack ? '元' : unitMap[discountType],
                useType: 'useType',
                status: ['LIMIT_ACTIVE', 'FREE_WITHDRAW', 'CASH_WITHDRAW'].includes(couponStatus) ? 'USED' : couponStatus
              })
            }
          } else if (['CASH', 'COUPON', 'REFUSE_PAY_PASSIVE', 'SHARED_CASH'].includes(item.couponType)) {
            this.list.push(item)
          } else if (['LIMIT', 'RIGHTS_INTERESTS', 'SVIP_RIGHTS_INTERESTS'].includes(item.couponType)) {
            this.couponsList.push(item)
          }
        })
      }
    },
    getPacketDescription (item) {
      return item.memberCouponDesc || TicketMaps.PacketDescMap[item.activeType]
    },

    getPacketType (item) {
      if (item.couponType === 'COUPON' || item.activeType === 'REDUCTION_INTEREST' || item.activeType === 'PERSON_REPEAT_LOAN') {
        return '免息红包'
      } else if (item.couponType === 'CASH') {
        if (item.activeType === 'XIAOMEI_VIP') {
          return '拒就赔现金红包'
        } else {
          return '现金红包'
        }
      } else if (item.couponType === 'LIMIT') {
        return '专享提额券'
      } else if (item.couponType === 'SHARED_CASH') {
        return '邀请新用户-返现红包'
      } else if (item.couponType === 'RIGHTS_INTERESTS') {
        if (item.memberGoodsGroupCd === 'SVIP') {
          return 'SVIP优惠券'
        } else {
          return item.supportMemberGoodsName ? item.supportMemberGoodsName + '优惠券' : 'VIP优惠券'
        }
      } else if (item.couponType === 'REFUSE_PAY_PASSIVE') {
        return '现金红包'
      }
    },

    getDiscountValue (item) {
      if ((item.activeType === 'XIAOMEI_VIP' || !['NEW_PERSON', 'PAY_IF_REFUSE_NEW', 'REDUCTION_INTEREST', 'PERSON_REPEAT_LOAN', 'DRAINAGE', 'NEW_PERSON'].includes(item.activeType)) && !item.discountAmt) {
        return ''
      } else {
        if (item.discountAmt <= 1 && item.discountWay === 'RATIO') {
          return (item.discountAmt * 10).toFixed(2).replace(/(?:\.0*|(\.\d+?)0+)$/, '$1')
        } else if (item.discountAmt) {
          return Number(item.discountAmt).toFixed(2)
        } else {
          return item.discountValue
        }
      }
    },

    getValidTimeDesc (item) {
      const { activeType, endTime, couponType, memberGoodsGroupCd } = item
      if (!endTime) return ''
      if ((activeType === 'XIAOMEI_VIP' && ['CASH', 'REFUSE_PAY_PASSIVE'].includes(couponType)) || memberGoodsGroupCd === 'KING' || ['SHARED_CASH'].includes(couponType)) {
        return `有效期至：${this.formatDate(endTime, 'YYYY/MM/DD hh:mm:ss')}`
      } else {
        return `红包激活有效期至：${this.formatDate(endTime, 'YYYY/MM/DD hh:mm:ss')}`
      }
    },

    getPacketIntrestDesc (item) {
      if (item.couponType === 'FREE_INTEREST') {
        return `免息${item.discountValue}天`
      } else {
        return ''
      }
    },


    getPacketUnit (item) {
      if (item.discountAmt || !['NEW_PERSON', 'PAY_IF_REFUSE_NEW', 'REDUCTION_INTEREST', 'PERSON_REPEAT_LOAN', 'DRAINAGE', 'NEW_PERSON'].includes(item.activeType)) {
        if (item.discountAmt <= 1 && item.discountWay === 'RATIO') {
          return '折'
        } else {
          return `元`
        }
      } else {
        return '天'
      }
    }
  }
}
</script>
<style lang='less'>
@import "../../assets/less/mixin.less";

 .van-tabs--line .van-tabs__wrap {
    height: 98px;
  }
  .van-tab {
    font-size: 36px;
    height: 98px;
    line-height: 98px;
  }
  .van-tab__text1 {
    height: 98px;
  }
    .van-ellipsis {
      margin-top: 23px;
      font-size:36px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      line-height:50px;
    }
</style>
<style lang='less' scoped>
@import "../../assets/less/mixin.less";

  .page {
    background-color: #FAFAFA;
    .list{
        height: 100%;
        overflow: scroll;
        padding-bottom: 50px;
    }
    .item {
        position: relative;
        background:linear-gradient(270deg,rgba(239,239,239,1) 0%,rgba(213,213,213,1) 100%);
        width: 670px;
        min-height: 180px;
        margin: 40px 40px 0px 40px;
        background-size: 100% 100%;
        border-radius: 20px;

        .description {
          font-size: 20px;
          font-family: PingFangSC-Regular,PingFang SC;
          font-weight: 400;
          color:rgba(255,255,255,1);
          line-height: 40px;
          padding: 0 15px;
          height: 40px;
          background-color: #FF756F;
          position: absolute;
          top: 0;
          left: 0;
          background: linear-gradient(270deg, #BFBFBF 0%, #9A9A9A 100%);
          border-radius: 20px 0px 20px 0px;
        }

        .center {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding-top: 65px;
          padding-left: 33px;

          .title {
            font-size:34px;
            font-family:PingFangSC-Semibold,PingFang SC;
            font-weight:600;
              color:rgba(255,255,255,1);
            line-height:48px;
          }

          .wapper {
            padding-right: 40px;
            .amount {
              font-size:50px;
              font-family:DIN-Medium,DIN;
              font-weight:500;
              color:rgba(255,255,255,1);
              line-height:61px;
            }
            .unit {
              font-size:28px;
              font-family:PingFangSC-Medium,PingFang SC;
              font-weight:500;
              color:rgba(255,255,255,1);
              line-height:40px;
            }
          }
        }
        .bottom {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding-left: 33px;
          margin: 5px 10px;
          .valid-time {
            font-size:20px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:28px;
          }
          .intrest-day {
            padding-right: 40px;
            padding-left: 50px;
            font-size:20px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:28px;
          }
        }
        .use-limit-desc{
          box-sizing:content-box;
          padding-left: 33px;
          padding-bottom: 24px;
          margin: 0px 10px 0;
          height: 28px;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 28px;
        }
        .status {
          position: absolute;
          right: 0px;
          top: 52px;
          transform: translateY(-50%);
          width: 104px;
          height: 104px;
        }
    }
    .no-data {
        width: 100%;
        text-align: center;
        img {
            width: 205px;
            height: 173px;
            margin-top: 263px;
            // margin-left: 173px;
        }

        .tips {
            font-size:28px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:36px;
            margin-top: 37px;
        }
        .sub-tips {
          font-size:24px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:36px;
            margin-top: 5px;
        }
    }
  }
</style>